<template>
    <!-- <strong v-if="important == true" class="template__important">중요해요</strong> -->
    <!-- <span class="marking" :class="[markingClass, important == true ? 'withImportant' : '']"></span> -->
    <!-- 큐뱅크와 폰트사이즈 맞추기 위해 큐뱅트 디폴트 사이즈인 16px 고정함 -->
    <h6 class="template__title" style="font-size: 16px" v-if="!isCsat">
        <div style="display: flex; align-items: end">
            <!-- <div :class="markingClass"> </div> -->
            <AnswerMarking :marking-class="markingClass" />
            <div class="template__no">{{ props.pContent?.problemNo }}.</div>
            <q-chip style="background-color: #ededed" text-color="black">
                {{ props.pContent.etcInfo?.analysis }}
            </q-chip>
            <!-- <q-chip>기본 문제 <span style="color: red;">O</span></q-chip> -->
            <q-chip v-if="drillChip.length > 0" style="background-color: #ededed" v-for="item in drillChip">
                {{ item.label }}
                <!-- <span style="color:red">{{ item.drill === 'up' ? 'O' : 'X' }}</span> -->
                <img v-if="item.drill === 'up'" style="margin-left: 5px; height: 16px" src="@/assets/images/icon/ico_drill_o.png" />
                <img v-if="item.drill !== 'up'" style="margin-left: 5px; height: 14px" src="@/assets/images/icon/ico_drill_x.png" />
                <!-- <q-icon :name="item.drill === 'up' ? 'radio_button_unchecked' : 'close'"
                    :style="item.drill === 'up' ? 'color:#EF2B2A ;' : '#4659FF'">
                </q-icon> -->
            </q-chip>
            <q-chip style="background-color: #d8f6ff" :style="props.pContent.etcInfo?.difficultCd === '05' ? 'background-color: #FFD8D8;' : props.pContent.etcInfo?.difficultCd === '03' ? 'background-color: #E8DFFF;' : ''">
                {{ props.pContent.etcInfo?.difficultNm }}</q-chip
            >
        </div>
    </h6>
    <div style="text-align: right;" v-if="isCsat && !markingClass">
        <q-radio
            v-if="choiceArrange"
            v-for="(item, index) in choiceArrange.data"
            :class="'col-' + 12 / (choiceArrange.array === '0' ? 1 : Number(choiceArrange.array))"
            style="margin: 1vh 12px 2vh 0.5vw;text-align: center;width: 1.2vw;height: 3.9vh;font-size: 1.4rem;"
            v-model="choice"
            :val="item.numChar"
            v-bind:class="rightAnswer !== null && rightAnswer === item.numChar ? 'omr-item-correct' : item.numChar === choice ? 'omr-item-select' : 'omr-item-nomal'"
            @update:model-value="onChangeAnswer"
            :disable="props.pContent.result && props.pContent.result.marking !== 'halfWrong'"
        >
            <div style="display: inline-flex; width: 100%;">
                <div style="display: flex; justify-content: center; align-items: center;">
                    <div class="item-num">
                        {{ item.num }}
                    </div>
                </div>
            </div>
        </q-radio>
    </div>
    <div>
        <!-- <q-input clearable outlined v-model="answer.value1" /> -->
        <!-- <span v-html="question"></span> -->
        <!-- <AnswerMarking :marking-class="markingClass" v-if="isCsat" style="margin-top: 38px;position: absolute" /> -->
        <AnswerMarking :marking-class="markingClass" v-if="isCsat && markingClass" />
        <!-- <AnswerMarking :marking-class="markingClass" v-if="isCsat" /> -->
        <div style="margin-left: 13px">
            <div v-html="question"></div>
            <!-- <v-runtime-template :template="question"></v-runtime-template> -->
        </div>
        <div class="row" style="width: 100%">
            <q-radio
                v-if="choiceArrange"
                v-for="(item, index) in choiceArrange.data"
                :class="'col-' + 12 / (choiceArrange.array === '0' ? 1 : Number(choiceArrange.array))"
                style="padding: 10px"
                v-model="choice"
                :val="item.numChar"
                v-bind:class="rightAnswer !== null && rightAnswer === item.numChar ? 'item-correct' : rightAnswer !== null && item.numChar === choice ? 'item-wrong' : item.numChar === choice ? 'item-select' : 'item-nomal'"
                @update:model-value="onChangeAnswer"
                :disable="props.pContent.result && props.pContent.result.marking !== 'halfWrong'"
            >
                <div style="display: inline-flex; width: 100%;">
                    <div style="display: flex; justify-content: center; align-items: flex-start; margin-right: 10px">
                        <div class="item-num">
                            <span v-if="!((rightAnswer !== null && rightAnswer === item.numChar) || (rightAnswer !== null && item.numChar === choice))">
                                {{ item.num }}
                            </span>
                            <q-icon
                                v-if="(rightAnswer !== null && rightAnswer === item.numChar) || (rightAnswer !== null && item.numChar === choice)"
                                :name="rightAnswer !== null && rightAnswer === item.numChar ? 'radio_button_unchecked' : item.numChar === choice ? 'close' : ''"
                                size="sm"
                                style="color: white"
                            />
                        </div>
                    </div>
                    <div v-html="item.text"></div>
                </div>
            </q-radio>
        </div>
        <!-- <q-option-group v-model="choice" :options="options" color="red" /> -->
    </div>
    <div></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineEmits, defineProps, watch, toRaw } from 'vue';
import { getQuestion_old, getChoice } from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import VRuntimeTemplate from 'vue3-runtime-template';
import AnswerMarking from './answerMarking.vue';
import { difficult, drill } from '@/helpers/qbankParser/qbankMeta';

const question = ref('');
const choiceArrange = ref([]);
const choice = ref('');
const rightAnswer = ref(null);
const isCsat = ref(false);
let markingClass = ref(null);
let drillChip = ref([]);

const emit = defineEmits(['setAnswer']);
const $q = useQuasar();

const props = defineProps({
    pContent: {
        default: {},
    },
    isCsat: false,
});

const onChangeAnswer = (v, evt) => {
    emit('setAnswer', v);
};

watch(
    () => props.pContent,
    (newValue) => {
        // const questionHeader = JSON.parse(JSON.stringify(newValue));
        const vContent = toRaw(newValue);
        // parsingContent(vContent.data.content);
        question.value = getQuestion_old(vContent.data, isCsat.value ? vContent.problemNo : false);
        changeHtmlString(question.value);
        choiceArrange.value = getChoice(vContent.data);
        rightAnswer.value = null;
        if (vContent.reAnswer) {
            choice.value = vContent.reAnswer;
        } else if (vContent.answer) {
            choice.value = vContent.answer;
        } else {
            choice.value = '';
        }
        if (vContent.result) {
            if (props.isCsat) {
                markingClass = 'marking-' + (vContent.result.marking === 'wrong' ? 'halfWrong' : 'right');
                if (vContent.result.marking) {
                    setTimeout(() => {
                        const item = document.querySelectorAll('.input_answers');
                        item.forEach((target) => {
                            target.setAttribute('readonly', true);
                        });
                    }, 200);
                    rightAnswer.value = vContent.data.content.solution.answer?.detail[0]?.answer;
                }
            } else {
                markingClass = 'marking-' + vContent.result.marking;
                if (vContent.result.marking !== 'halfWrong') {
                    setTimeout(() => {
                        const item = document.querySelectorAll('.input_answers');
                        item.forEach((target) => {
                            target.setAttribute('readonly', true);
                        });
                    }, 200);
                    rightAnswer.value = vContent.data.content.solution.answer?.detail[0]?.answer;
                }
            }
        } else {
            markingClass = '';
        }

        drillChipsInit(vContent);
    },
);

//  쓸데없는 style 정리.
const changeHtmlString = (text) => {
    let _hSetence = text;
    // console.log('-초기값-problemChoice--', _hSetence); 
    _hSetence = _hSetence.replace('font-weight:700;', 'font-size:15.6pt;'); // 우선순위10 -번호의 폰트사이즈 변경 
    _hSetence = _hSetence.replace('text-indent:0px;">', 'text-indent:0px; font-weight:700">'); // 우선순위20 -최상단div(문제라인) weight 주기 
    _hSetence = _hSetence.replace('text-indent:-45.5px;">', 'text-indent:-45.5px; font-weight:700">'); // 우선순위20 -최상단div(문제라인) weight 주기 
    _hSetence = _hSetence.replace('margin-left:45.5px;margin-right:0px;text-indent:-45.5px;"><div', 'margin-left:0px;margin-right:0px;text-indent:-45.5px;"><div'); // 우선순위30 -보기의 indent 제거.
    question.value = _hSetence;
    // console.log('-수정완료-problemChoice--', _hSetence);
};

onMounted(() => {
    const vContent = toRaw(props.pContent);
    isCsat.value = props.isCsat;
    question.value = getQuestion_old(vContent.data, isCsat.value ? vContent.problemNo : false);
    changeHtmlString(question.value);
    choiceArrange.value = getChoice(vContent.data);
    // if (vContent.answer && vContent.answer.length > 0) {
    //     vContent.answer.map(i => {
    //         setTimeout(() => {
    //             document.getElementById('choiceList_' + i).checked = true;
    //         }, 100);
    //     })
    // }
    rightAnswer.value = null;
    if (vContent.reAnswer) {
        choice.value = vContent.reAnswer;
    } else if (vContent.answer) {
        choice.value = vContent.answer;
    } else {
        choice.value = '';
    }
    if (vContent.result) {
        if (props.isCsat) {
            markingClass = 'marking-' + (vContent.result.marking === 'wrong' ? 'halfWrong' : 'right');
            if (vContent.result.marking) {
                setTimeout(() => {
                    const item = document.querySelectorAll('.input_answers');
                    item.forEach((target) => {
                        target.setAttribute('readonly', true);
                    });
                }, 200);
                rightAnswer.value = vContent.data.content.solution.answer?.detail[0]?.answer;
            }
        } else {
            markingClass = 'marking-' + vContent.result.marking;
            if (vContent.result.marking !== 'halfWrong') {
                setTimeout(() => {
                    const item = document.querySelectorAll('.input_answers');
                    item.forEach((target) => {
                        target.setAttribute('readonly', true);
                    });
                }, 200);
                rightAnswer.value = vContent.data.content.solution.answer?.detail[0]?.answer;
            }
        }
    } else {
        markingClass = '';
    }

    drillChipsInit(vContent);
});

const drillChipsInit = (vContent) => {
    drillChip.value = [];
    if (vContent.problemClassCode === '3') {
        if (vContent.baseDifficult === '03') {
            drillChip.value.push({ label: difficult['03'].label, drill: 'down' });
        } else {
            for (var a = Number(vContent.baseDifficult); a > Number(vContent.etcInfo.difficultCd); a--) {
                drillChip.value.push({ label: difficult['0' + a].label, drill: 'down' });
            }
        }
    }
    if (vContent.problemClassCode === '2') {
        for (var a = Number(vContent.baseDifficult); a < Number(vContent.etcInfo.difficultCd); a++) {
            drillChip.value.push({ label: difficult['0' + a].label, drill: 'up' });
        }
    }
};

onUnmounted(() => {
    //
    drillChip.value = [];
});
</script>

<style lang="scss" scoped>
.template {
    &__no {
        font-size: 20px; // 큐뱅크 폰트 사이즈와 차이 나지 않게 큐뱅크 디폴트 사이즈인 16보다 조금 크게 설정
        margin: 0px 13px;
    }
}

::v-deep input {
    // width: 500px;
    // height: 32px;
    // font-size: 15px;

    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;
    outline: none;
    margin: 0px 5px;
    text-align: center;
    max-width: 100%;
}

::v-deep textarea {
    // width: 500px;
    // height: 32px;
    // font-size: 15px;

    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;
    outline: none;
    margin: 0px 5px;
    max-width: 100%;
}

::v-deep p {
    margin: 0px;
}

.radio {
    &__wrap {
        grid-template-columns: repeat(2, size(120));
        grid-template-rows: repeat(2, size(120));
    }
}

.direction__frame {
    border: 1px solid;
    padding: 10px;
    font-size: size(12);
}

.distracter {
    margin-top: size(16);
    counter-reset: number;

    .checkbox {
        display: block;
        position: relative;
        width: 100%;
        min-height: size(55);
        margin-bottom: size(20);
        background: white;
        border-radius: size(10);
        border-bottom: size(5) solid #eef3f5;
        box-shadow: 0 size(1) size(5) 0 rgba(64, 87, 1, 0.15);
        font-size: size(17);
        font-weight: 500;

        &__wrap {
            &.arrange2 {
                display: flex;
                flex-wrap: wrap;
                margin: size(-10);

                .checkbox {
                    width: calc(100% / 2 - #{size(20)});
                    margin: size(10);
                }
            }

            &.arrange3 {
                display: flex;
                flex-wrap: wrap;
                margin: size(-10);

                .checkbox {
                    width: calc(100% / 3 - #{size(20)});
                    margin: size(10);
                }
            }

            &.horizontal {
                display: flex;
                margin: size(-10);

                .checkbox {
                    margin: size(10);
                }
            }

            .card-item {
                margin-right: 10px;
                @include center-element;
            }
        }

        &__label {
            // display: block;
            display: inline-flex;
            align-items: center;
            position: relative;
            width: 100%;
            // padding: size(16) size(10) size(16) size(32);
            padding: size(16) size(10) size(16) size(10);
            min-height: size(55);
            line-height: 1.31;
            background: white;
            border-radius: size(10);

            &:before {
                // counter-increment: number;
                // content: counter(number);
                display: inline-flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: size(16);
                left: size(10);
                width: size(14);
                height: size(14);
                margin-right: size(5);
                border: size(1) solid #000;
                border-radius: 100%;
                font-size: size(12);

                & + u {
                    margin-left: 0;
                }
            }
        }

        input {
            display: none;

            &:checked {
                & + .checkbox__label {
                    box-sizing: border-box;

                    &:after {
                        content: '';
                        display: block;
                        width: 100%;
                        height: 100%;
                        border: size(2.5) solid #3a3a3a;
                        position: absolute;
                        left: 0;
                        top: 0;
                        box-sizing: border-box;
                        border-radius: 9px;
                    }

                    &.correct {
                        border-color: #00a7ff;
                        color: #00a7ff;

                        &:before,
                        &:after {
                            border-color: #00a7ff;
                            color: #00a7ff;
                        }

                        ::v-deep u {
                            color: #00a7ff;
                        }
                    }

                    &.wrong {
                        border-color: #ff0000;
                        color: #ff0000;

                        &:before,
                        &:after {
                            border-color: #ff0000;
                            color: #ff0000;
                        }

                        ::v-deep u {
                            color: #ff0000;
                        }
                    }
                }
            }
        }
    }
}

.template {
    .direction {
        &__thumb {
            padding: size(12.5) 0;
            border: none;
        }

        &__textbox {
            line-height: 1.4;

            ::v-deep > div {
                min-height: size(17);
            }
        }
    }
}

::v-deep .textbox_inputImg {
    vertical-align: middle;
}

.disableTouch {
    touch-action: none;
    pointer-events: none;
}

::v-deep .q-radio__inner {
    display: none;
}

::v-deep .item {
    &-nomal {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            border-radius: 20px;
            border: 1px solid #bdbdbd;
            color: #bdbdbd;
            padding: 0px 8px 2px;
        }
    }

    &-select {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            border-radius: 20px;
            border: 1px solid #4659ff;
            background-color: #4659ff;
            color: white;
            padding: 0px 8px 2px;
        }
    }

    &-correct {
        // background-color: #d7eaff;
        border-radius: 10px;

        .item-num {
            border: 1px solid #4659ff;
            background-color: #4659ff;
            color: white;
            border-radius: 20px;
            padding: 2px;
            border-radius: 50%;
        }
    }

    &-wrong {
        // background-color: #ffc8d6;
        border-radius: 10px;

        .item-num {
            border: 1px solid #ef2b2a;
            background-color: #ef2b2a;
            border-radius: 20px;
            padding: 2px;
            border-radius: 50%;
        }
    }
}

::v-deep .omr-item {
    &-nomal {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            border: 1px solid #4659FF;
            color: #4659FF;
            padding: 0px 4px;
            font-weight: 500;
        }
    }

    &-select {
        // background-color: #efefef;
        border-radius: 10px;

        .item-num {
            border-radius: 20px;
            border: 1px solid Black;
            background-color: Black;
            color: white;
            font-weight: 500;
            padding: 0px 4px;
        }
    }
}

::v-deep .disabled {
    opacity: 1 !important;
}
</style>
